<div class="pr-4 pt-3">
  <button
    type="button"
    (click)="close()"
    class="close btn btn-xs btn-icon btn-light btn-hover-primary"
  >
    <i class="ki ki-close icon-xs text-muted"></i>
  </button>
</div>
<div
  #wizard
  id="kt_wizard_v3"
  class="card-body wizard wizard-3 navi-hover"
  data-wizard-state="step-first"
>
  <div class="kt-grid__item">
    <!--begin: Form Wizard Nav -->
    <div class="wizard-nav border-bottom">
      <div class="wizard-steps pl-10">
        <a class="wizard-step template-details" data-wizard-type="step" data-wizard-state="current">
          <div class="wizard-label">
            <div class="wizard-title">Task Template</div>
            <div class="wizard-bar"></div>
          </div>
        </a>
        <a
          class="wizard-step"
          data-wizard-type="step"
          data-wizard-state=""
          *ngIf="defaultViewValue === 'CHECK_LIST'"
        >
          <div class="wizard-label">
            <div class="wizard-title">Checklist</div>
            <div class="wizard-bar"></div>
          </div>
        </a>
        <a class="wizard-step" data-wizard-type="step">
          <div class="wizard-label">
            <div class="wizard-title">Additional Steps</div>
            <div class="wizard-bar"></div>
          </div>
        </a>
        <a class="wizard-step" data-wizard-type="step">
          <div class="wizard-label">
            <div class="wizard-title">Related Templates</div>
            <div class="wizard-bar"></div>
          </div>
        </a>
        <a class="wizard-step" data-wizard-type="step">
          <div class="wizard-label">
            <div class="wizard-title">Task Actions</div>
            <div class="wizard-bar"></div>
          </div>
        </a>
        <a class="wizard-step" data-wizard-type="step">
          <div class="wizard-label">
            <div class="wizard-title">Process Navigator</div>
            <div class="wizard-bar"></div>
          </div>
        </a>
        <a class="wizard-step" data-wizard-type="step">
          <div class="wizard-label">
            <div class="wizard-title">Manage Blockers</div>
            <div class="wizard-bar"></div>
          </div>
        </a>
        <a class="wizard-step" data-wizard-type="step">
          <div class="wizard-label">
            <div class="wizard-title">Quick Comments</div>
            <div class="wizard-bar"></div>
          </div>
        </a>
        <a class="wizard-step" data-wizard-type="step">
          <div class="wizard-label">
            <div class="wizard-title">AI Definition</div>
            <div class="wizard-bar"></div>
          </div>
        </a>
      </div>
    </div>
    <!--end: Form Wizard Nav -->
  </div>
  <!--begin: Form Wizard Form-->
  <form
    class="form"
    [formGroup]="templateForm"
    style="height: 450px; overflow-y: scroll; overflow-x: hidden"
  >
    <!--begin: Form Wizard Step 0-->
    <div class="py-8" data-wizard-type="step-content" data-wizard-state="current">
      <div class="row mb-5">
        <div class="first-card-form">
          <kt-alert
            *ngIf="hasFormErrors"
            type="warn"
            [duration]="30000"
            [showCloseButton]="true"
            (closeAl)="onAlertClose()"
          >
            <span translate="GLOBAL.FORM_ERROR"></span>
          </kt-alert>
          <div class="form-group row">
            <div class="col-lg-12 kt-margin-bottom-20-mobile">
              <mat-form-field appearance="fill" class="mat-form-field-fluid">
                <mat-label translate="TASK_TEMPLATE.NAME">Name</mat-label>
                <input matInput formControlName="name" required maxlength="255" />
                <mat-error *ngIf="isControlHasError('name', 'required')">
                  Required field
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-12 kt-margin-bottom-20-mobile">
              <kt-general-autocomplete
                [label]="'Team/Category'"
                [loadItemsFunction]="categoryAutocompleteCall"
                [optionFormatter]="filterCategoryFn"
                [valueFormatter]="filterCategoryFn"
                [required]="true"
                [readOnly]="isReadOnly"
                [control]="templateForm.get('category')"
                [change]="onCategoryChange.bind(this)"
                [dataPath]="'data'"
                [placeholder]="'Select'"
                #categoryAutocomplete
              ></kt-general-autocomplete>
            </div>
            <div class="col-lg-12 kt-margin-bottom-20-mobile">
              <mat-form-field appearance="fill" class="mat-form-field-fluid">
                <mat-label translate="TASK_TEMPLATE.TITLE">Main Task</mat-label>
                <input matInput formControlName="title" required />
                <mat-error *ngIf="isControlHasError('title', 'required')">
                  Required field
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-12 kt-margin-bottom-20-mobile">
              <mat-form-field appearance="fill" class="mat-form-field-fluid">
                <mat-label>{{ 'TASK.SET_PRIORITY' | translate }}</mat-label>
                <mat-select formControlName="priority">
                  <mat-select-trigger>
                    <span
                      *ngIf="templateForm.controls['priority'].value !== 'LOW'"
                      [class]="getPriority(templateForm.controls['priority'].value)"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="4px"
                        height="24px"
                        viewBox="0 0 24 24"
                        version="1.1"
                      >
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect x="0" y="0" width="24" height="24" />
                          <path
                            d="M8,4 L16,4 C17.1045695,4 18,4.8954305 18,6 L18,17.726765 C18,18.2790497 17.5522847,18.726765 17,18.726765 C16.7498083,18.726765 16.5087052,18.6329798 16.3242754,18.4639191 L12.6757246,15.1194142 C12.2934034,14.7689531 11.7065966,14.7689531 11.3242754,15.1194142 L7.67572463,18.4639191 C7.26860564,18.8371115 6.63603827,18.8096086 6.26284586,18.4024896 C6.09378519,18.2180598 6,17.9769566 6,17.726765 L6,6 C6,4.8954305 6.8954305,4 8,4 Z"
                            fill="#000000"
                          />
                        </g>
                      </svg>
                    </span>
                    {{ getPriorityText(templateForm.controls['priority'].value) }}
                  </mat-select-trigger>
                  <mat-option *ngFor="let option of priorityOptions" [value]="option">
                    <span *ngIf="option !== 'LOW'" [class]="getPriority(option)">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24px"
                        height="24px"
                        viewBox="0 0 24 24"
                        version="1.1"
                      >
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect x="0" y="0" width="24" height="24" />
                          <path
                            d="M8,4 L16,4 C17.1045695,4 18,4.8954305 18,6 L18,17.726765 C18,18.2790497 17.5522847,18.726765 17,18.726765 C16.7498083,18.726765 16.5087052,18.6329798 16.3242754,18.4639191 L12.6757246,15.1194142 C12.2934034,14.7689531 11.7065966,14.7689531 11.3242754,15.1194142 L7.67572463,18.4639191 C7.26860564,18.8371115 6.63603827,18.8096086 6.26284586,18.4024896 C6.09378519,18.2180598 6,17.9769566 6,17.726765 L6,6 C6,4.8954305 6.8954305,4 8,4 Z"
                            fill="#000000"
                          />
                        </g>
                      </svg>
                    </span>
                    <span *ngIf="option === 'LOW'" style="height: 26px; width: 26px">&nbsp;</span>
                    {{ getPriorityText(option) }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-lg-12 kt-margin-bottom-20-mobile">
              <mat-form-field appearance="fill" class="mat-form-field-fluid">
                <mat-label translate="TASK_TEMPLATE.DEFAULT_VIEW">Default View</mat-label>
                <mat-select formControlName="default_view" [(value)]="defaultViewValue">
                  <mat-option>None</mat-option>
                  <mat-option value="CHECK_LIST">Checklist</mat-option>
                  <mat-option value="FORM">Form</mat-option>
                  <mat-option value="INTERVENTION" *ngIf="data.mode !== 'additional_step'"
                    >Intervention</mat-option
                  >
                </mat-select>
                <mat-error *ngIf="isControlHasError('default_view', 'required')">
                  Required field
                </mat-error>
              </mat-form-field>
            </div>
            <div
              class="col-lg-12 kt-margin-bottom-20-mobile d-flex align-items-start"
              *ngIf="defaultViewValue === 'FORM'"
            >
              <div class="flex-grow-1">
                <kt-general-autocomplete
                  #formAutocomplete
                  [label]="'FORMS_TEMPLATES_MODULE.FORM.SCHEMA.FORM' | translate"
                  [dataPath]="'data'"
                  [loadItemsFunction]="getFormAutocomplete"
                  [optionFormatter]="formatFormOption"
                  [valueFormatter]="formatFormOption"
                  [required]="defaultViewValue === 'FORM'"
                  [readOnly]="isReadOnly"
                ></kt-general-autocomplete>
              </div>
              <ng-template ngxPermissionsOnly="canViewForm">
                <button
                  matTooltip="{{ 'TABLE.VIEW' | translate }} Form"
                  class="btn btn-icon btn-light btn-hover-success ml-4"
                  (click)="viewForm($event)"
                >
                  <span
                    inlineSVG="assets/media/svg/icons/General/visible.svg"
                    class="svg-icon svg-icon-md svg-icon-success"
                  ></span>
                </button>
              </ng-template>
              <ng-template ngxPermissionsOnly="accessToSynonyms">
                <button
                  [matTooltip]="'FORMS_TEMPLATES_MODULE.FORM.LINK_TITLE' | translate"
                  class="btn btn-icon btn-light btn-hover-danger ml-2"
                  (click)="linkFormFieldsToSynonyms($event)"
                >
                  <span
                    inlineSVG="assets/media/svg/icons/General/link.svg"
                    class="svg-icon svg-icon-md svg-icon-danger"
                  ></span>
                </button>
              </ng-template>
            </div>
            <div class="col-lg-12 kt-margin-bottom-20-mobile">
              <kt-general-autocomplete
                [label]="'Assign To'"
                [loadItemsFunction]="assigneeAutocompleteCall"
                [optionFormatter]="filterAssigneeFn"
                [valueFormatter]="filterAssigneeFn"
                [required]="false"
                [readOnly]="isReadOnly"
                [control]="templateForm.get('task_responsible_users')"
                [change]="onAssigneeChange.bind(this)"
                [dataPath]="'data'"
                [placeholder]="'Select Assignees'"
                [formatNewObjectFn]="formatNewAssigneeFn"
                [chipList]="true"
                [objects]="templateForm.get('task_responsible_users').value"
                #assigneeAutocomplete
              ></kt-general-autocomplete>
            </div>
            <div class="col-lg-12" style="padding-top: 10px">
              <mat-form-field class="mat-form-field-fluid" appearance="fill">
                <mat-label>{{ 'TASK.URL_RESOURCE' | translate }}</mat-label>
                <div class="row">
                  <div class="col-11">
                    <input
                      matInput
                      type="url"
                      formControlName="url_resource"
                      placeholder="ex: https://example.com"
                      (focusout)="validateUrl()"
                      [readonly]="disableEditing"
                    />
                  </div>
                  <div *ngIf="showExternalLinkIcon()" class="col-1">
                    <i class="fas fa-external-link-alt" (click)="openExternalLink()"></i>
                  </div>
                </div>
                <mat-error *ngIf="isControlHasError('url_resource', 'pattern')">
                  Invalid URL Resource
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-12 kt-margin-bottom-20-mobile">
              <kt-general-autocomplete
                [label]="'Followers'"
                [loadItemsFunction]="assigneeAutocompleteCall"
                [optionFormatter]="filterAssigneeFn"
                [valueFormatter]="filterAssigneeFn"
                [required]="false"
                [readOnly]="isReadOnly"
                [control]="templateForm.get('task_followers')"
                [change]="onFollowerChange.bind(this)"
                [dataPath]="'data'"
                [placeholder]="'Select Followers'"
                [formatNewObjectFn]="formatNewFollowerFn"
                [chipList]="true"
                [objects]="templateForm.get('task_followers').value"
                #followerAutocomplete
              ></kt-general-autocomplete>
            </div>
            <div class="col-12 mb-4">
              <kt-general-autocomplete
                #programAutocomplete
                [label]="'Program'"
                [dataPath]="'data'"
                [loadItemsFunction]="getProgramAutocomplete"
                [optionFormatter]="formatProgramOption"
                [valueFormatter]="formatProgramOption"
                [control]="templateForm.get('program')"
                [change]="onProgramChange.bind(this)"
                [required]="false"
                [readOnly]="isReadOnly"
              ></kt-general-autocomplete>
            </div>
            <div class="col-12 mb-4">
              <kt-general-autocomplete
                [label]="'Standards'"
                [loadItemsFunction]="getStandardAutocomplete"
                [optionFormatter]="formatStandardOption"
                [valueFormatter]="formatStandardOption"
                [formatNewObjectFn]="formatNewStandard"
                [control]="templateForm.get('standards')"
                [objects]="templateForm.get('standards').value"
                [change]="onStandardChange.bind(this)"
                [required]="false"
                [readOnly]="!templateForm.get('program').value || isReadOnly"
                [chipList]="true"
                [dataPath]="'data'"
              ></kt-general-autocomplete>
            </div>
            <div class="col-lg-12 kt-margin-bottom-20-mobile">
              <mat-form-field appearance="fill" class="mat-form-field-fluid">
                <mat-label translate="TASK_TEMPLATE.DESCRIPTION">Description</mat-label>
                <textarea matInput formControlName="description" rows="4"></textarea>
              </mat-form-field>
            </div>
            <div class="col-lg-12 kt-margin-bottom-20-mobile">
              <div class="mat-form-field-fluid">
                <section class="example-section">
                  <label class="example-margin col-5">Active:</label>
                  <mat-slide-toggle class="mr-2" formControlName="is_active"></mat-slide-toggle>
                  <mat-hint align="start">
                    <strong>{{ getStatusString(templateForm.get('is_active').value) }}</strong>
                  </mat-hint>
                </section>
              </div>
            </div>
            <div class="col-lg-12 kt-margin-bottom-20-mobile">
              <div class="mat-form-field-fluid">
                <section class="example-section">
                  <label class="example-margin col-5">Allow create by all roles:</label>
                  <mat-slide-toggle class="mr-2" formControlName="all_roles"></mat-slide-toggle>
                  <mat-hint align="start">
                    <strong>{{ getStatusString(templateForm.get('all_roles').value) }}</strong>
                  </mat-hint>
                </section>
              </div>
            </div>
            <div class="col-lg-12 kt-margin-bottom-20-mobile">
              <div class="mat-form-field-fluid">
                <section class="example-section">
                  <label class="example-margin col-5">Allow payments:</label>
                  <mat-slide-toggle class="mr-2" formControlName="allow_payment"></mat-slide-toggle>
                  <mat-hint align="start">
                    <strong>{{ getStatusString(templateForm.get('allow_payment').value) }}</strong>
                  </mat-hint>
                </section>
              </div>
            </div>
            <div class="col-lg-12 kt-margin-bottom-20-mobile">
              <div class="mat-form-field-fluid">
                <section class="example-section">
                  <label class="example-margin col-5">Exclude from focused view:</label>
                  <mat-slide-toggle class="mr-2" formControlName="isExclude"></mat-slide-toggle>
                  <mat-hint align="start">
                    <strong>{{ getStatusString(templateForm.get('isExclude').value) }}</strong>
                  </mat-hint>
                </section>
              </div>
            </div>
            <div class="col-lg-12 kt-margin-bottom-20-mobile">
              <div class="mat-form-field-fluid">
                <section class="example-section">
                  <label class="example-margin col-5">Configure as backstage task:</label>
                  <mat-slide-toggle class="mr-2" formControlName="is_backstage"></mat-slide-toggle>
                  <mat-hint align="start">
                    <strong>{{ templateForm.get('is_backstage').value ? 'Yes' : 'No' }}</strong>
                  </mat-hint>
                </section>
              </div>
            </div>
            <div class="col-lg-12 kt-margin-bottom-20-mobile">
              <div class="mat-form-field-fluid">
                <section class="example-section">
                  <label class="example-margin col-5">Portal service:</label>
                  <mat-slide-toggle class="mr-2" formControlName="is_service"></mat-slide-toggle>
                  <mat-hint align="start">
                    <strong>{{ getStatusString(templateForm.get('is_service').value) }}</strong>
                  </mat-hint>
                  <mat-hint
                    *ngIf="
                      templateForm.get('default_view').value !== 'FORM' &&
                      templateForm.get('default_view').value !== 'CHECK_LIST'
                    "
                    align="end"
                  >
                    Only Form or Checklist templates can be portal services
                  </mat-hint>
                </section>
              </div>
            </div>
            <div class="col-lg-12 kt-margin-bottom-20-mobile">
              <div class="mat-form-field-fluid">
                <section class="example-section">
                  <label class="example-margin col-5">Private service:</label>
                  <mat-slide-toggle
                    class="mr-2"
                    formControlName="is_private_service_allowed"
                  ></mat-slide-toggle>
                  <mat-hint align="start">
                    <strong>{{
                      getStatusString(templateForm.get('is_private_service_allowed').value)
                    }}</strong>
                  </mat-hint>
                </section>
              </div>
            </div>
            <div
              class="col-lg-12 kt-margin-bottom-20-mobile"
              *ngIf="userInfo?.userType === 'Admin'"
            >
              <div class="mat-form-field-fluid">
                <section class="example-section">
                  <label class="example-margin col-5">Lock this template:</label>
                  <mat-slide-toggle class="mr-2" formControlName="is_locked"></mat-slide-toggle>
                  <mat-hint align="start">
                    <strong>{{ templateForm.get('is_locked').value ? 'Yes' : 'No' }}</strong>
                  </mat-hint>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end: Form Wizard Step 0-->

    <!--begin: Form Wizard Step 1-->
    <div class="py-8" data-wizard-type="step-content" *ngIf="defaultViewValue === 'CHECK_LIST'">
      <div class="card-body">
        <kt-checklist-template
          [mode]="mode"
          [templateId]="template?.id"
          [lockedByAdmin]="lockedByAdmin"
        ></kt-checklist-template>
      </div>
    </div>
    <!--end: Form Wizard Step 1-->

    <!--begin: Form Wizard Step 2-->
    <div class="py-8" data-wizard-type="step-content">
      <div class="card-body">
        <kt-additional-steps
          *ngIf="mode !== 'additional_step'"
          [templateId]="template?.id"
          [mode]="mode"
          (emittedAdditionalStep)="additionalStepValue($event)"
          (emittedCanAddAdditionalStep)="setAdditionalStepValue($event)"
          [lockedByAdmin]="lockedByAdmin"
        ></kt-additional-steps>
        <div
          class="alert alert-custom alert-outline-2x alert-outline-danger fade show mb-5"
          role="alert"
          *ngIf="mode === 'additional_step'"
          style="width: 100%"
        >
          <div class="alert-icon"><i class="flaticon-warning"></i></div>
          <div class="alert-text">
            This template is a step of another one, so you can't include more steps in it.
          </div>
        </div>
      </div>
    </div>
    <!--end: Form Wizard Step 2-->

    <!--begin: Form Wizard Step 3-->
    <div class="py-8" data-wizard-type="step-content">
      <div class="card-body">
        <kt-related-templates [mode]="mode" [templateId]="template?.id"></kt-related-templates>
      </div>
    </div>
    <!--end: Form Wizard Step 3-->

    <!--begin: Form Wizard Step 4-->
    <div class="py-8" data-wizard-type="step-content">
      <div class="card-body">
        <kt-task-actions-tab
          *ngIf="mode !== 'additional_step'"
          [templateId]="template?.id"
          [mode]="mode"
          [additionalSteps]="emittedAdditionalSteps"
          [canSetAdditionalSteps]="emittedCanAddAdditionalSteps"
          [lockedByAdmin]="lockedByAdmin"
        ></kt-task-actions-tab>
        <div
          class="alert alert-custom alert-outline-2x alert-outline-danger fade show mb-5"
          role="alert"
          *ngIf="mode === 'additional_step'"
          style="width: 100%"
        >
          <div class="alert-icon"><i class="flaticon-warning"></i></div>
          <div class="alert-text">
            This template is a step of another one, so you can't include task actions in it.
          </div>
        </div>
      </div>
    </div>
    <!--end: Form Wizard Step 4-->

    <!--begin: Form Wizard Step 5-->
    <div class="px-10 py-8" data-wizard-type="step-content">
      <kt-add-process-nav-resource
        [mode]="mode"
        [templateId]="template?.id"
        [templateType]="TemplateType.TASK_TEMPLATE"
      ></kt-add-process-nav-resource>
    </div>
    <!--end: Form Wizard Step 5-->

    <!--begin: Form Wizard Step 6-->
    <div class="py-8" data-wizard-type="step-content">
      <kt-add-blocker
        [mode]="mode"
        [templateId]="template?.id"
        [templateType]="TemplateType.TASK_TEMPLATE"
      ></kt-add-blocker>
    </div>
    <!--end: Form Wizard Step 6-->

    <!--begin: Form Wizard Step 7-->
    <div class="py-8" data-wizard-type="step-content">
      <kt-quick-comments [mode]="mode" [templateId]="template?.id"></kt-quick-comments>
    </div>
    <!--end: Form Wizard Step 7-->

    <!--begin: Form Wizard Step 8-->
    <div class="py-8" data-wizard-type="step-content">
      <div class="card-body">
        <kt-task-template-ai-tab
          [form]="templateForm"
          [templateId]="template?.id"
          [readOnly]="isReadOnly"
          (saveTemplateAi)="onSubmit()"
        ></kt-task-template-ai-tab>
      </div>
    </div>
    <!--end: Form Wizard Step 8-->
  </form>

  <!--begin: Form Actions -->
  <div class="d-flex justify-content-between footer-wiz">
    <div class="mr-2">
      <div
        class="btn btn-light-primary font-weight-bold text-uppercase"
        data-wizard-type="action-prev"
      >
        <span translate="GLOBAL.PREVIOUS">Previous</span>
      </div>
    </div>
    <div>
      <button
        class="btn btn-primary font-weight-bold text-uppercase"
        data-wizard-type="action-submit"
        (click)="close()"
      >
        <span>Finish</span>
      </button>
      <div class="btn btn-primary font-weight-bold text-uppercase" data-wizard-type="action-next">
        <span>{{ getButtonText() }}</span>
      </div>
    </div>
  </div>
  <!--end: Form Wizard Form-->
</div>
